import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthRoute } from './components/guards/AuthRoute';
import { SuperAdminRoute } from './components/guards/SuperAdminRoute';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { ApplicationsPage } from './pages/Applications';
import { DirectionsPage } from './pages/Directions';
import { UsersPage } from './pages/Users';
import { OffboardingPage } from './pages/Offboarding';
import { OffboardingDetailPage } from './pages/OffboardingDetail';
import { ReviewsPage } from './pages/Reviews';
import { ReviewDetailPage } from './pages/ReviewDetail';
import { AdminsPage } from './pages/Admins';
import { VerificationPage } from './pages/Verification';
import { MyTasksPage } from './pages/MyTasks';
import { SettingsPage } from './pages/Settings';
import { ActivityLogsPage } from './pages/ActivityLogs';
import { EmailTemplatesPage } from './pages/EmailTemplates';
import { RolesPage } from './pages/Roles';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/dashboard"
            element={
              <AuthRoute>
                <DashboardPage />
              </AuthRoute>
            }
          />

          <Route
            path="/applications"
            element={
              <SuperAdminRoute>
                <ApplicationsPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/directions"
            element={
              <SuperAdminRoute>
                <DirectionsPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/users"
            element={
              <SuperAdminRoute>
                <UsersPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/offboarding"
            element={
              <SuperAdminRoute>
                <OffboardingPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/offboarding/:id"
            element={
              <SuperAdminRoute>
                <OffboardingDetailPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/reviews"
            element={
              <AuthRoute>
                <ReviewsPage />
              </AuthRoute>
            }
          />

          <Route
            path="/reviews/:id"
            element={
              <AuthRoute>
                <ReviewDetailPage />
              </AuthRoute>
            }
          />

          <Route
            path="/admins"
            element={
              <SuperAdminRoute>
                <AdminsPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/my-tasks"
            element={
              <AuthRoute>
                <MyTasksPage />
              </AuthRoute>
            }
          />

          <Route
            path="/verification-request/:id"
            element={
              <AuthRoute>
                <VerificationPage />
              </AuthRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <SuperAdminRoute>
                <SettingsPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/activity-logs"
            element={
              <SuperAdminRoute>
                <ActivityLogsPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/email-templates"
            element={
              <SuperAdminRoute>
                <EmailTemplatesPage />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/roles"
            element={
              <SuperAdminRoute>
                <RolesPage />
              </SuperAdminRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster />
      </Router>
    </AuthProvider>
  );
}

export default App;
